module.exports = __webpack_public_path__ + "static/media/sell_help_9.ca3aadd7.png";